// extracted by mini-css-extract-plugin
module.exports = {"day":"day-1H8PU"};